import { Icon } from "../Icon.tsx";
import "./card.css";

type Props = {
  image?: string;
  altText?: string;
};

export const Image = ({ image, altText }: Props) => {
  return (
    <>
      {image ? (
        <img alt={altText} loading="lazy" src={image} className="card-image inset-0 object-cover" />
      ) : (
        <div className="card-image flex justify-center items-center s-bg-subtle">
          <Icon name="Image" size="56px" className="s-icon-subtle" />
        </div>
      )}
    </>
  );
};

export const PersonImage = ({ image, altText }: Props) => {
  return (
    <>
      {image ? (
        <img alt={altText} loading="lazy" src={image} className="rounded-full object-cover w-[112px] h-[112px]" />
      ) : (
        <div className="rounded-full object-cover w-[112px] h-[112px] flex justify-center items-center s-bg-subtle">
          <Icon name="CircleUser" size="56px" className="s-text-disabled" />
        </div>
      )}
    </>
  );
};
